
export class FileUploadConstants {
    public static CATEGORY_PERMISSIONS = [
        { identifier: 'bonusReissue', permissionId: 290 },
        { identifier: 'recognition', permissionId: 346  },
        { identifier: 'japanData', permissionId: 303  }
    ];
    public static CSV_FILE_EXTENSION = 'csv';
    public static PRINT = 'print';
    public static ERROR_COLUMN = 'ERROR';
    public static STRING_TYPE = 'string';
    public static BATCH_INITIATATION_PATH = 'batch-processing/file-uploads/initiated/';
    public static TEMPLATE_HEADERS = [
        {
            templateName: 'Local on the rise',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Network Marketing Professional Incentives',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Forever 2 Drive',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Global Rally Qualifiers',
            headers: [
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'LEVEL',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Eagles Managers Qualifiers',
            headers: [
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Chairmans Bonus Qualifiers',
            headers: [
                'PROCESSING_YEAR',
                'POSITION',
                'LEVEL',
                'FBO_ID',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Local Incentives',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Top 20 Business Builders',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Move Ups',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: '4CC Incentive',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Team Building Incentive',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'VIP Incentive',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response'
            }
        },
        {
            templateName: '5075100 Club',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Top Region',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response'
            }
        },
        {
            templateName: 'Sponsor of the Month',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response'
            }
        },
        {
            templateName: 'Retailer of the Month',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response'
            }
        },
        {
            templateName: 'Top 30 Business Builders',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response'
            }
        },
        {
            templateName: 'Top 30 Open Business',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response'
            }
        },
        {
            templateName: 'Forever2Drive',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Manager Incentive',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Your Business Times Two',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Product Retail Incentive',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Regional Incentive',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response'
            }
        },
        {
            templateName: 'Seasonal Incentive',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'LEVEL',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response',
                LEVEL: 'level_response'
            }
        },
        {
            templateName: 'Seasonal Incentive2',
            headers: [
                'PROCESSING_MONTH',
                'PROCESSING_YEAR',
                'POSITION',
                'FBO_ID',
                'FBO_NAME',
                'CITY_NAME',
                'STATE_NAME',
                'OPERATING_COUNTRY'
            ],
            validations: {
                PROCESSING_MONTH: /^(0?[1-9]|1[012])$/,
                PROCESSING_YEAR: /^[0-9]{4}$/,
                POSITION: /^[0-9]*$/,
                FBO_ID: /^(\d{3}-\d{3}-\d{3}-\d{3}|\d{12})$/,
                FBO_NAME: /[^\s]/,
                OPERATING_COUNTRY: 'country_response'
            }
        }
    ];
}



// WEBPACK FOOTER //
// ./src/app/customerservice/constants/file-upload.constants.ts